import { Chip, type SxProps, type Theme } from '@mui/material'
import { type ReactElement } from 'react'

const chipStyle = (iconColor: string | undefined, hasIcon: boolean): SxProps<Theme> => ({
  height: '24px',
  borderRadius: '12px',
  backgroundColor: 'var(--grey-50)',
  border: '1px solid var(--grey-200)',
  boxShadow: 'var(--shadow-xs)',
  color: 'var(--grey-900)',
  fontFamily: 'Open Sans',
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '18px',
  '& .MuiChip-label': {
    padding: hasIcon ? '0 10px 0 4px' : '0 10px'
  },
  '& .MuiChip-icon': {
    fontSize: '16px',
    margin: '0 0 0 10px',
    color: iconColor
  }
})

interface StatusChipProps {
  label: string
  icon?: ReactElement
  iconColor?: string
  dataTestId?: string
}

export const StatusChip = ({ label, icon, iconColor, dataTestId }: StatusChipProps): JSX.Element => (
  <Chip
    label={label}
    size='small'
    variant='outlined'
    icon={icon}
    data-testid={dataTestId}
    sx={chipStyle(iconColor, icon != null)}
  />
)
